import React, {
  useEffect,
  useState
} from 'react';

import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import validate from 'validate.js';

import { Box } from '@mui/material';

import Footer from '../Common/components/Footer';

import AuthHeader from './components/AuthHeader';
import AuthHero from './components/AuthHero';

import SignInForm from './components/SignInForm';
import ForgotUsernameForm from './components/ForgotUsernameForm';
import ForgotPasswordForm from './components/ForgotPasswordForm';

import {
  FORM_VIEW,
  getInitialFormState,
  getSchema
} from './utils/authFormConfig';

import {
  contentSx,
  mainContentSx,
  pageSx,
  signInSectionSx
} from '../Common/components/Styles/AuthStyles';

const SignIn = ({ history }) => {
  const [formView, setFormView] = useState(
    FORM_VIEW.SIGN_IN
  );

  const [formState, setFormState] = useState(
    getInitialFormState(FORM_VIEW.SIGN_IN)
  );

  useEffect(() => {
    const errors = validate(
      formState.values,
      getSchema(formView)
    );

    setFormState(currentState => ({
      ...currentState,
      errors: errors || {},
      isValid: !errors
    }));
  }, [
    formState.values,
    formView
  ]);

  const switchFormView = view => {
    setFormView(view);
    setFormState(getInitialFormState(view));
  };

  const handleChange = event => {
    const {
      name,
      value
    } = event.target;

    setFormState(currentState => ({
      ...currentState,

      values: {
        ...currentState.values,
        [name]: value
      },

      touched: {
        ...currentState.touched,
        [name]: true
      }
    }));
  };

  const markAllFieldsTouched = () => {
    const touched = Object.keys(
      formState.values
    ).reduce(
      (result, field) => ({
        ...result,
        [field]: true
      }),
      {}
    );

    setFormState(currentState => ({
      ...currentState,
      touched
    }));
  };

  const hasError = field => {
    return Boolean(
      formState.touched[field] &&
      formState.errors[field]
    );
  };

  const handleSignIn = event => {
    event.preventDefault();

    markAllFieldsTouched();

    if (!formState.isValid) {
      return;
    }

    history.push('/default');
  };

  const handleForgotUsernameSubmit = event => {
    event.preventDefault();

    markAllFieldsTouched();

    if (!formState.isValid) {
      return;
    }

    console.log(
      'Forgot username submitted:',
      {
        email: formState.values.email
      }
    );

    // Call forgot username API here.
  };

  const handleForgotPasswordSubmit = event => {
    event.preventDefault();

    markAllFieldsTouched();

    if (!formState.isValid) {
      return;
    }

    console.log(
      'Forgot password submitted:',
      {
        email: formState.values.email,
        username: formState.values.username
      }
    );

    // Call forgot password API here.
  };

  const renderForm = () => {
    switch (formView) {
      case FORM_VIEW.FORGOT_USERNAME:
        return (
          <ForgotUsernameForm
            formState={formState}
            hasError={hasError}
            onBack={() =>
              switchFormView(
                FORM_VIEW.SIGN_IN
              )
            }
            onChange={handleChange}
            onSubmit={
              handleForgotUsernameSubmit
            }
          />
        );

      case FORM_VIEW.FORGOT_PASSWORD:
        return (
          <ForgotPasswordForm
            formState={formState}
            hasError={hasError}
            onBack={() =>
              switchFormView(
                FORM_VIEW.SIGN_IN
              )
            }
            onChange={handleChange}
            onSubmit={
              handleForgotPasswordSubmit
            }
          />
        );

      default:
        return (
          <SignInForm
            formState={formState}
            hasError={hasError}
            onChange={handleChange}
            onForgotPassword={() =>
              switchFormView(
                FORM_VIEW.FORGOT_PASSWORD
              )
            }
            onForgotUsername={() =>
              switchFormView(
                FORM_VIEW.FORGOT_USERNAME
              )
            }
            onSubmit={handleSignIn}
          />
        );
    }
  };

  return (
    <Box sx={pageSx}>
      <AuthHeader />

      <Box
        component="main"
        sx={contentSx}>
        <Box sx={mainContentSx}>
          <AuthHero />

          <Box
            component="section"
            sx={signInSectionSx}>
            {renderForm()}
          </Box>
        </Box>
      </Box>

      <Footer />
    </Box>
  );
};

SignIn.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};

export default withRouter(SignIn);